"use client"
import React from 'react'
import { useRegion } from '@/app/hooks/use-region'

// 地域限制闸门（全站统一做法）：restricted=true（"海外"游戏）时按浏览器 IP 判定，
// 大陆（不含港澳台）不渲染内容、展示地区不可用提示；海外/接口失败正常展示；?isoversea=1 可预览
// 注意：restricted 的页面 SSR/首帧只输出加载占位，内容需客户端判定后才渲染
export interface RegionGateTexts {
    title: string
    desc: string
    back: string
}

export default function RegionGate({ restricted, texts, backHref, children }: {
    restricted: boolean
    texts: RegionGateTexts
    backHref: string
    children: React.ReactNode
}) {
    const region = useRegion()

    if (!restricted) return <>{children}</>

    if (region === 'checking') {
        return (
            <div className="flex min-h-[70vh] items-center justify-center bg-slate-950">
                <span className="h-8 w-8 animate-spin rounded-full border-2 border-white/15 border-t-indigo-400" />
            </div>
        )
    }

    if (region === 'cn') {
        return (
            <div className="flex min-h-[70vh] items-center justify-center bg-slate-950 px-6">
                <div className="max-w-md rounded-2xl bg-slate-900 ring-1 ring-white/10 p-8 text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor"
                        className="mx-auto h-10 w-10 text-slate-500">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0 3.75h.008v.008H12v-.008ZM12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" />
                    </svg>
                    <h2 className="mt-4 text-lg font-bold text-white">{texts.title}</h2>
                    <p className="mt-2 text-sm leading-6 text-slate-400">{texts.desc}</p>
                    <a href={backHref}
                        className="mt-6 inline-flex items-center gap-2 rounded-full bg-indigo-600 hover:bg-indigo-500 px-6 py-2.5 text-sm font-bold text-white transition-colors">
                        {texts.back}
                    </a>
                </div>
            </div>
        )
    }

    return <>{children}</>
}
